import React, { Suspense } from 'react'
import { Router } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { renderAuthenticated, renderUnAuthenticated } from './navigator'
import Fallback from './shared/Fallback'
import { history, RootState } from './reducers'

function App(): JSX.Element {
  // Subscribe to user state to trigger re-render on login/logout
  useSelector((state: RootState) => state.user)

  const isAuthenticated =
    localStorage.getItem('user') !== 'null' &&
    localStorage.getItem('user') !== null

  return (
    <Suspense fallback={<Fallback />}>
      <Router history={history}>
        {isAuthenticated ? renderAuthenticated() : renderUnAuthenticated()}
      </Router>
    </Suspense>
  )
}

export default App
